// extracted by mini-css-extract-plugin
export default {"root":"VerifiedHandoffBadge_root__g8GAq"};